import {
  CloseButton,
  MissionName,
  Reward,
  SWiperItemContent,
  StarButton,
  SwiperItem,
  SwiperItemIcon,
  Wrapper,
} from './QuestsSwiperCard.styles';
import WrapperBox from 'components/WrapperBox';
import { theme } from 'twin.macro';
import XMark from 'Icons/XMark';
import ChevronRight from 'Icons/ArrowRight';
import questSwiperICon from 'assets/icons/questSwiper.png';
import coin from 'assets/icons/coins/coin.png';
import QuestInfo from '../QuestInfo';
import { CoinImage } from 'components/MarkerPopup/MarkerPopup.styles';
import { useTranslation } from 'react-i18next';
import { QuestSwiperCardProps } from './QuestsSwiperCard.types';

const QuestsSwiperCard = ({
  missionCoins,
  missionDistance,
  missionLevel,
  missionName,
  onStart,
  onClose,
}: QuestSwiperCardProps) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <WrapperBox
        width="297px"
        height="20.438rem"
        shadowColor={theme`colors.green`}
        borderWidth="3px"
        shadowSpace="10px"
      >
        <SwiperItem>
          <CloseButton
            bgColor={theme`colors.softGray`}
            hasAfter={true}
            afterBg={theme`colors.green`}
            isRounded={true}
            onClick={onClose}
            aria-label="close-marker-popup"
          >
            <XMark />
          </CloseButton>
          <StarButton
            width="15.801rem"
            height="3.813rem"
            hasAfter={false}
            isRounded={false}
            rotation="-2.36deg"
            shadowColor="black"
            onClick={onStart}
          >
            {t('startmission')}
            <ChevronRight />
          </StarButton>

          <SwiperItemIcon src={questSwiperICon} alt={missionName} />
          <SWiperItemContent>
            <MissionName>
              <QuestInfo label={t('missionName')} title={missionName} />
              <QuestInfo label={t('level')} title={t(missionLevel)} />
            </MissionName>
            <MissionName>
              {missionDistance && (
                <QuestInfo label={t('distance')} title={missionDistance} />
              )}
              <Reward>
                <p>{missionCoins || 0}</p>
                <CoinImage src={coin} alt={missionCoins + ''} />
              </Reward>
            </MissionName>
          </SWiperItemContent>
        </SwiperItem>
      </WrapperBox>
    </Wrapper>
  );
};

export default QuestsSwiperCard;
